import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { useMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const WrapperBackgroundColor = 'bg.default'
const NumberBackgroundColor = 'bg.panel'
const BlockedNumberStyleParts = [
  'outerWrapper',
  'wrapper',
  'headerWrapper',
  'header',
  'numberWrapper',
  'headerText',
  'headerSubtext',
  'blockedNumberWrapper',
  'blockedNumberText',
  'modal',
] as const
const helpers = createMultiStyleConfigHelpers(BlockedNumberStyleParts)
export const BlockedNumberStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    outerWrapper: {
      maxWidth: '600px',
      width: { base: '100%', xl: '50%' },
      minHeight: '10%',
      maxHeight: '100%',
      flexShrink: 0,
      borderRadius: '8px',
    },
    wrapper: {
      flex: 1,
      borderRadius: '8px',
      display: 'flex',
      backgroundColor: WrapperBackgroundColor,
      borderWidth: '1px',
      borderColor: 'border.default',
      alignSelf: 'stretch',
      flexDirection: 'column',
      minHeight: '10%',
      maxHeight: '100%',
      flexShrink: 0,
    },
    headerWrapper: {
      height: '6.65rem',
      alignSelf: 'stretch',
      padding: '16px',
      flexDirection: 'column',
      backgroundColor: WrapperBackgroundColor,
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '1.75rem',
      alignSelf: 'stretch',
    },
    numberWrapper: {
      flex: 1,
      padding: '1.25rem',
      gap: '0.625rem',
      display: 'flex',
      borderTop: '2px solid',
      borderColor: 'border.default',
      flexDirection: 'column',
      alignItems: 'center',
      alignSelf: 'stretch',
      overflowY: 'auto',
    },
    headerText: {
      width: '24.75rem',
      height: '1.25rem',
      ...textStyles[textStyleKeys.Body2_Bold],
    },
    headerSubtext: {
      width: '34rem',
      height: '1rem',
      ...textStyles[textStyleKeys.Body2],
      marginTop: '1rem',
    },
    blockedNumberWrapper: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingLeft: '0.5rem',
      paddingRight: '0.5rem',
      paddingTop: '0.1rem',
      justifyContent: 'space-between',
      gap: '0.625rem',
      width: '33rem',
      height: '2.25rem',
      border: '1px solid',
      borderColor: 'border.default',
      borderRadius: '8px',
      flexShrink: 0,
      backgroundColor: NumberBackgroundColor,
    },
    blockedNumberText: {
      ...textStyles[textStyleKeys.Body2],
    },
  },
})
export const useBlockedNumberStyles = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(BlockedNumberStyles, props) as MultiStyleType<
    typeof BlockedNumberStyleParts
  >
}
